import ScheduleEventModel from "@/schedule/entities/schedule-event";
import { format } from "date-fns";
import Task from "../../../schedule/entities/schedule-calendar-task";

export default class ScheduleEvent {
  public eventId: number;
  public userId: number;
  public projectId: number;
  public projectName: string;
  public title: string;
  public description: string;
  public start: string;
  public end: string;
  public editable: boolean;

  // TODO: 使ってるのか？
  public tasks: Task[];

  public constructor(event: ScheduleEventModel) {
    this.eventId = event.id;
    this.userId = event.userId;
    this.projectId = event.projectId;
    this.projectName = event.projectName;
    this.title = event.title;
    this.description = event.description;
    this.start = format(event.start, "H:mm");
    this.end = format(event.end, "H:mm");
    this.editable = false;
    this.tasks = event.tasks;
  }
}
